export default __webpack_public_path__ + "static/media/The Immortal Edge.228a9fd2.jpg";